export default class  CustomerReportActions {

  static NEW_DATA = 'NEW_DATA';
  static UPDATE_DATA='UPDATE_DATA';
  static SHOW_DATA='SHOW_DATA';
  static VIEW_DATA='VIEW_DATA';
  static DELETE_DATA='DELETE_DATA';
  static ON_SUBMIT='ON_SUBMIT';
  static ERROR_DATA='ERROR_DATA';
  static PROCESS_DATA='PROCESS_DATA';
  static RESET_DATA='RESET_DATA';
  static GET_HELPER_CUSTOMERREPORT='GET_HELPER_CUSTOMERREPORT';
  static SUCCESS_DATA='SUCCESS_DATA';
  static ERROR_SERVER='ERROR_SERVER';
  static RESET_LIST='RESET_LIST';
  static BEFORE_PRINT_CUSTOMERREPORT='BEFORE_PRINT_CUSTOMERREPORT';
  static PRINT_CUSTOMERREPORT='PRINT_CUSTOMERREPORT';
  static submit(){
    return {
      type:  CustomerReportActions.ON_SUBMIT
    };
  }

  static create(data) {
    return {
      type:  CustomerReportActions.NEW_DATA,
      payload: data
    };
  }

  static update(data) {
    return {
      type:  CustomerReportActions.UPDATE_DATA,
      payload: data
    };
  }

  static view(data) {
    return {
      type:  CustomerReportActions.VIEW_DATA,
      payload: data
    };
  }

  static delete(data) {
    return {
      type:  CustomerReportActions.DELETE_DATA
    };
  }

  static list(data) {
    return {
      type:  CustomerReportActions.SHOW_DATA,
      payload: data
    };
  }
  static resetList() {
    return {
      type:  CustomerReportActions.RESET_LIST
    };
  }
  static error(error){
    return {
      type:  CustomerReportActions.ERROR_DATA,
      payload: error
    };
  }
  static success(){
    return {
      type:  CustomerReportActions.SUCCESS_DATA,
    };
  }
  static process(){
    return {
      type:  CustomerReportActions.PROCESS_DATA,
    };
  }
  static reset(){
    return {
      type:  CustomerReportActions.RESET_DATA,
    };
  }
  static helper(data){
    return {
      type:  CustomerReportActions.GET_HELPER_CUSTOMERREPORT,
      payload:data
    };
  }
  static errorInternal(error){
    return {
      type:  CustomerReportActions.ERROR_SERVER,
      payload: error
    };
  }
  static beforePrint(){
    return {
      type: CustomerReportActions.BEFORE_PRINT_CUSTOMERREPORT,
    };
  }
  static print(printCustomerReport){
    return {
      type: CustomerReportActions.PRINT_CUSTOMERREPORT,
      payload: printCustomerReport
    };
  }
}